import React from 'react';
import PropTypes from 'prop-types';
import RejectLogPanel from '../quality-map/RejectLogPanel';
import QualityCheckedSummary from '../quality-map/QualityCheckedSummary';
import QualityRemakesSummary from '../quality-map/QualityRemakesSummary';
import '../quality-map/QualityMap.css';

export default function QualityTab({ date }) {
  return (
    <div>
      <RejectLogPanel date={date} />

      <div className="quality-critical-section" style={{ marginTop: 28 }}>
        <h3 className="quality-critical-section-title" style={{ margin: '0 0 4px' }}>
          Critical — Right First Time
        </h3>
        <QualityCheckedSummary date={date} />
        <QualityRemakesSummary date={date} />
      </div>
    </div>
  );
}

QualityTab.propTypes = {
  date: PropTypes.string.isRequired
};
